/**
 * BRAND CONFIGURATION — The Orchid Hotels
 * =======================================
 *
 * Single source of truth for every display string, asset URL and brand
 * identifier visible across the public site, login screens and admin sidebar.
 *
 * Powered by Fundle (the underlying loyalty platform).
 */

export const BRAND = {
  // -- Identity --------------------------------------------------------
  name: "THE ORCHID",                          // Header / sidebar wordmark
  legalName: "The Orchid Hotels",              // Footer copyright
  domain: "orchidhotel.com",
  shortDescriptor: "Asia's first 5-star eco-luxury hotel chain",

  // -- Platform identity (Fundle = the loyalty engine running this app)
  platform: "Fundle",
  poweredBy: "Powered by Fundle",
  aiAssistant: "Orchid Brain",
  platformLogoUrl: "/fundle-logo.png",

  // -- Loyalty programme branding -------------------------------------
  loyaltyProgramName: "Orchid Petals",
  pointsName: "Petals",                        // (custom — used in CMS / copy)
  welcomePointsValue: 500,
  welcomeToast: "Welcome to Orchid Petals — 500 Petals credited to your account.",
  ctaJoinFree: "Join Orchid Petals Free",

  // -- Social --------------------------------------------------------
  social: {
    instagram: "https://www.instagram.com/theorchidhotels/",
    facebook: "https://www.facebook.com/TheOrchidHotels/",
    youtube: "https://www.youtube.com/@theorchidhotels",
    linkedin: "https://www.linkedin.com/company/the-orchid-mumbai",
  },

  // -- SEO / meta ----------------------------------------------------
  meta: {
    title: "Orchid Petals — The Orchid Hotels Loyalty Programme",
    description:
      "Orchid Petals is the official loyalty programme of The Orchid Hotels — Asia's first 5-star eco-luxury chain. Earn Petals on every stay, dine and spa visit. Unlock complimentary nights, suite upgrades and members-only privileges across 25+ properties in India.",
  },

  // -- Public home copy (CMS overrides take precedence at runtime) ----
  homeCopy: {
    heroEyebrow: "An Eco-Luxury Programme · Powered by Fundle",
    heroSubtext:
      "The official loyalty programme of The Orchid Hotels. Every stay earns you Petals — redeemable for complimentary nights, suite upgrades, signature dining and rejuvenating spa experiences across 25+ eco-luxury destinations.",
    heroImageAlt: "Eco-luxury hotel pool at sunset — The Orchid Hotels",
    boutiqueImageAlt: "Elegant lobby at The Orchid Hotels",
    editorialImageAlt: "Sustainable luxury suite interior",
  },

  // -- Footer copy ----------------------------------------------------
  footerTagline:
    "The official loyalty programme of The Orchid Hotels — where every stay becomes a privilege. Luxury that's kind to the planet.",

  // -- Login / portal copy --------------------------------------------
  loginCopy: {
    descriptor:
      "A unified command centre for loyalty, CRM, analytics and guest intelligence — purpose-built for The Orchid Hotels.",
    imageAlt: "The Orchid Hotels",
  },

  // -- Brand colour palette ------------------------------------------
  // Eco-luxury: deep botanical green primary + warm champagne accent
  // on an ivory backdrop. Variable NAMES stay --kazo-* (50+ components
  // reference them); only the VALUES change.
  colors: {
    black: "#0B1A14",          // --kazo-black           (deep botanical charcoal — header / footer / sidebar)
    cream: "#FBF7EE",          // --kazo-cream           (ivory page background)
    burgundy: "#1F5135",       // --kazo-burgundy        (PRIMARY — eco-luxury forest green)
    burgundyDeep: "#143524",   // --kazo-burgundy-deep   (hover / pressed state)
    champagne: "#C9A86E",      // --kazo-champagne       (secondary accent — warm gold)
    champagneLight: "#E8D6A8", // --kazo-champagne-light (light champagne tint backgrounds)
  },
};

export default BRAND;
